import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import Button from 'components/Button';
import {
  StyledCaption,
  StyledCard,
  StyledGrid,
  StyledIcon,
  StyledLongBody,
} from 'components/ItemInfoCard/styles';
import { LastRefundsInfoCardProps } from 'components/ItemInfoCard/types';
import StatusChip from 'components/StatusChip';
import { Captions } from 'components/Typography';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React from 'react';
import PAGES from 'routes/pages';
import { uppercase } from 'utils/string';

const LastRefundsInfoCard = (props: LastRefundsInfoCardProps) => {
  const {
    styles,
    firstInformationLabel,
    firstInformationValue,
    secondInformationLabel,
    secondInformationValue,
    title,
    status,
    buttonLabel,
    wrapperPaddingLeft,
    wrapperPaddingRight,
    redirectionPath,
    statusLabel,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <StyledCard
      backgroundImage={styles.backgroundImage}
      backgroundColor={styles.backgroundColor}
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom="17px"
      >
        <Grid item xs={6}>
          <Grid container alignItems="center">
            {styles.icon && (
              <StyledGrid item xs={3} textAlign="center" height="30px">
                <StyledIcon
                  width={matches ? '28px' : '34px'}
                  height={matches ? '28px' : '34px'}
                  src={AssuranceIcon[styles.icon]}
                  alt="item-icon"
                />
              </StyledGrid>
            )}
            <Grid item xs={9}>
              <Box paddingLeft="15px" paddingTop="3px">
                <StyledLongBody matches={matches} color={styles.titleColor}>
                  {title}
                </StyledLongBody>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <StyledGrid item xs={6} textAlign="end">
          <StatusChip
            status={status}
            label={statusLabel ? uppercase(statusLabel) : ''}
          />
        </StyledGrid>
      </StyledGrid>
      <Grid container justify="space-between">
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <StyledCaption
              color={styles.labelsColor || '#9797AF'}
              marginBottom="6px"
            >
              {firstInformationLabel ? uppercase(firstInformationLabel) : ''}
            </StyledCaption>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="6px"
              textAlign="end"
            >
              {firstInformationValue}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <Captions color={styles.labelsColor || '#9797AF'}>
              {secondInformationLabel ? uppercase(secondInformationLabel) : ''}
            </Captions>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              textAlign="end"
              marginBottom="15px"
            >
              {secondInformationValue}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <GaClickHOC
              category={EVENT_CATEGORIES.AMC_ACCUEIL}
              label="Dernier remboursement_Voir details"
            >
              <Button
                variant="outlined"
                className={styles.buttonRootStyles}
                size="small"
                onClick={() => {
                  props.setDetailsPageBreadcrumbsPath([
                    { name: 'amc', route: PAGES.AMC_DASHBOARD },
                    { name: 'mesRemboursements' },
                  ]);
                  pushTo(redirectionPath);
                }}
              >
                {buttonLabel}
              </Button>
            </GaClickHOC>
          </Grid>
        </Grid>
      </Grid>
    </StyledCard>
  );
};

export default LastRefundsInfoCard;
